import { c as _c } from "react/compiler-runtime";
import { Image } from '@xefi/x-react/image';
import { t } from 'i18next';
import type { Preview } from './FileCard/types';
type FilePreviewProps = {
  preview: Preview;
};
export const FilePreview = t0 => {
  const $ = _c(5);
  const {
    preview
  } = t0;
  let t1;
  if ($[0] !== preview) {
    t1 = "isBase64" in preview && preview.isBase64 ? `data:${preview.type};base64,${preview.data}` : URL.createObjectURL(preview as File);
    $[0] = preview;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = t("attachment.label");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Image src={t1} alt={t2} />;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};